export const canonRFLLensDataSet = [
    {
        id: "4549292152272",
        EANCode: "4549292152272",
        maker: "Canon",
        name: "RF15-35mm F2.8 L IS USM",
        mount: "RF",
        focalLength: [15, 35],
        fStop: [2.8],
        format: "Full-Frame",
        focus: ["AF"],
        hasStabilizer: true,
        hasDustMoistureResistance: true,
        filterDiameter: 82,
        weight: 840,
        releaseDate: "2019-09-27",
        urls: {
            kakaku: "https://kakaku.com/item/K0001185356/",
        },
    },
    {
        id: "4549292148381",
        EANCode: "4549292148381",
        maker: "Canon",
        name: "RF24-70mm F2.8 L IS USM",
        mount: "RF",
        focalLength: [24, 70],
        fStop: [2.8],
        format: "Full-Frame",
        focus: ["AF"],
        hasStabilizer: true,
        hasDustMoistureResistance: true,
        filterDiameter: 82,
        weight: 900,
        releaseDate: "2019-09-27",
        officialUrl: "https://global.canon/en/c-museum/product/rf485.html",
        urls: {
            kakaku: "https://kakaku.com/item/K0001185357/",
            amazonjp: "https://www.amazon.co.jp/dp/B07WQYHH1Q",
        },
    },
    {
        id: "4549292156263",
        EANCode: "4549292156263",
        maker: "Canon",
        name: "RF70-200mm F2.8 L IS USM",
        mount: "RF",
        focalLength: [70, 200],
        fStop: [2.8],
        format: "Full-Frame",
        focus: ["AF"],
        hasStabilizer: true,
        hasDustMoistureResistance: true,
        filterDiameter: 77,
        weight: 1070,
        releaseDate: "2019-11-21",
        officialUrl: "https://global.canon/en/c-museum/product/rf486.html",
        urls: {
            kakaku: "https://kakaku.com/item/K0001205003/",
        },
    },
];
